import React, {FC, lazy, Suspense} from 'react';
import {Section} from 'templates/reports/query';
import {Section as Config} from 'templates/reports/types';

import {MeasureTypes} from './MeasureTypes';

const LazyChart = lazy(() => import('templates/reports/Section/RmrEstimate/Chart/RmrPlot'));

const DynamicChart: FC<ChartProps> = (props) => (
	<Suspense fallback={null}>
		<LazyChart {...props} />
	</Suspense>
);

type ChartProps = {
	cfg: Config['details']['historical']
	rmr: Section
}

export const Chart: FC<ChartProps> = ({cfg, rmr}) => {
	return (
		<div>
			<h2>Estimated RMR (Graph)</h2>
			<div>
				<p>
					This chart displays the most commonly used and most accurate
					equations for estimating RMR. These can help give you a range for
					your RMR and help you better understand your metabolism.
				</p>
			</div>
			<DynamicChart cfg={cfg} rmr={rmr} />
			<MeasureTypes />
		</div>
	);
};
